import { Tree, Modal } from "antd";
import isEmpty from "lodash/isEmpty";
import isString from "lodash/isString";
import isEqual from "lodash/isEqual";
import isArray from "lodash/isArray";
import forEach from "lodash/forEach";
import cloneDeep from "lodash/cloneDeep";
import uniq from "lodash/uniq";
import WeaTools from "../../wea-tools";
import WeaAvatar from "../../wea-avatar";
import GroupDialog from "./GroupDialog";
import { getLabel } from "../../wea-locale-provider/util";

const TreeNode = Tree.TreeNode;

function objToArray(obj) {
  if (!isArray(obj)) {
    let arr = [];
    arr.push(obj);
    obj = arr;
  }
  return obj;
}

const getHash = () =>
  Math.random()
    .toString(36)
    .substr(2, 6);

export function getKeys({ subs, depts }, topPrefix = "wea") {
  const expandedKeys = [];
  if (!isEmpty(subs) || !isEmpty(depts)) {
    const nodeids = [...subs, ...depts];
    nodeids.reduce((total, nodeid) => {
      let key = `${total ? total : `${topPrefix}0`}-${nodeid}`;
      expandedKeys.push(key);
      return key;
    }, "");
  }
  return expandedKeys;
}

const text = (item, field) => {
  let text = "";
  if (item[field] !== undefined) {
    text = item[field];
  }
  if (item[field + "span"] !== undefined) {
    text = item[field + "span"];
  }
  return text;
};

class Main extends React.Component {
  constructor(props) {
    super(props);
    const { defaultExpandedKeys, treeData } = props;
    this.generateData = generateData.bind(this);
    this.generateTreeNodes = generateTreeNodes.bind(this);
    this.getNewTreeData = getNewTreeData.bind(this);
    this.state = {
      expandedKeys: defaultExpandedKeys || [],
      ztreeExpandedKeys: defaultExpandedKeys || [],
      selectedKeys: [],
      treeData: treeData || [],
      defaultExpandedKeys: defaultExpandedKeys || [],
      checkedKeys: [],
      radioCheckedData: props.radioCheckedData || "",
      checkedDatas: props.checkedDatas || [],
      checkStrictly: props.checkStrictly || false
    };
    this.browserTreeKey = getHash();
  }
  componentWillMount() {
    const { ztreeMode, isHrmTree } = this.props;
    const { treeData, defaultExpandedKeys } = this.state;
    const tempExpandedKeys = [...defaultExpandedKeys];
    if (!ztreeMode || (ztreeMode && !isHrmTree)) {
      this.generateData(treeData, 1, tempExpandedKeys);
    }
  }
  componentDidMount() {
    const {
      checkedDatas,
      defaultCurrentUser,
      asynLoadAll,
      defaultExpandedLevel
    } = this.props;
    const { treeData, defaultExpandedKeys } = this.state;
    const tempExpandedKeys = [...defaultExpandedKeys];
    if (asynLoadAll || defaultExpandedLevel) {
      this.fetchChildDatas();
    } else {
      const newState = {
        treeData: objToArray(treeData),
        defaultExpandedKeys: tempExpandedKeys,
        expandedKeys: tempExpandedKeys
      };
      if (!isEmpty(checkedDatas)) {
        newState.checkedKeys = this.formatCheckDatas(checkedDatas);
      }
      this.setState(newState, () => {
        if (!isEmpty(defaultCurrentUser) && !isEmpty(this.state.treeData)) {
          this.expandChild(
            defaultCurrentUser,
            this.state.treeData[0],
            this.focusCurrentUser
          );
        }
      });
    }
  }
  componentWillReceiveProps(nextProps) {
    const {
      componyParam,
      ztreeMode,
      isHrmTree,
      defaultCurrentUser
    } = this.props;
    let { checkStrictly } = this.state;
    const tempExpandedKeys = [...this.state.defaultExpandedKeys];
    if (componyParam && componyParam != nextProps.componyParam) {
      //虚拟维度
      this.generateData(nextProps.treeData);
      this.setState({
        expandedKeys: nextProps.defaultExpandedKeys,
        treeData: objToArray(nextProps.treeData)
      });
    }
    if (!isEqual(this.props.treeData, nextProps.treeData)) {
      //初始树数据
      if (!ztreeMode || (ztreeMode && !isHrmTree)) {
        this.generateData(nextProps.treeData, 1, tempExpandedKeys);
      }
      this.setState(
        {
          treeData: objToArray(nextProps.treeData),
          defaultExpandedKeys: tempExpandedKeys,
          expandedKeys: tempExpandedKeys
        },
        () => {
          if (
            !isEmpty(nextProps.defaultCurrentUser) &&
            !isEmpty(this.state.treeData)
          ) {
            this.expandChild(
              nextProps.defaultCurrentUser,
              this.state.treeData[0],
              this.focusCurrentUser
            );
          }
        }
      );
    }
    if ("checkedDatas" in nextProps && nextProps.checkedDatas != undefined) {
      if (
        !isEqual(this.props.checkedDatas, nextProps.checkedDatas) ||
        !isEqual(this.state.checkedDatas, nextProps.checkedDatas)
      ) {
        //多选数据受控
        let checkedKeys = this.formatCheckDatas(nextProps.checkedDatas);
        this.updateExpandedKeys(checkedKeys, nextProps.defaultExpandedKeys);
        this.setState({
          checkedKeys,
          checkedDatas: nextProps.checkedDatas
        });
      }
    }
    if ("radioCheckedData" in nextProps) {
      if (!isEqual(this.state.radioCheckedData, nextProps.radioCheckedData)) {
        //单选数据受控
        this.setState({ radioCheckedData: nextProps.radioCheckedData });
      }
    }
    // if (
    //   "defaultExpandedKeys" in nextProps &&
    //   !isEqual(this.props.defaultExpandedKeys, nextProps.defaultExpandedKeys)
    // ) {
    //   //初始展开的树节点
    //   this.setState({
    //     defaultExpandedKeys: nextProps.defaultExpandedKeys,
    //     expandedKeys: nextProps.defaultExpandedKeys
    //   });
    //   if (this.state.checkedKeys && this.state.checkedKeys.length > 0) {
    //     this.updateExpandedKeys(
    //       this.state.checkedKeys,
    //       nextProps.defaultExpandedKeys
    //     );
    //   }
    // }
    if (
      "checkStrictly" in nextProps &&
      !isEqual(checkStrictly, nextProps.checkStrictly)
    ) {
      checkStrictly = nextProps.checkStrictly;
      this.setState({ checkStrictly });
    }
  }
  formatCheckDatas(checkedDatas) {
    let keys = [];
    if (isArray(checkedDatas) && checkedDatas.length > 0) {
      forEach(this.treeDataList, (item, key) => {
        if (checkedDatas.some(d => d.id == item.id && d.name == item.name)) {
          keys.push(key);
        }
      });
    }
    return keys;
  }
  updateExpandedKeys(checkedKeys, expandedKeys) {
    expandedKeys = expandedKeys || this.state.expandedKeys;
    if (isArray(checkedKeys) && checkedKeys.length > 0) {
      let parentIds = [];
      checkedKeys.forEach(k => parentIds.push(this.treeDataList[k].pid));
      forEach(this.treeDataList, (item, key) => {
        if (parentIds.some(d => d == item.id)) {
          expandedKeys.push(key);
        }
      });
    }
    expandedKeys = uniq([...expandedKeys, ...this.state.expandedKeys]);
    this.setState({ expandedKeys });
  }
  focusCurrentUser = () => {
    const { defaultCurrentUser } = this.props;
    if (isEmpty(defaultCurrentUser)) return;
    setTimeout(() => {
      let localeDept = defaultCurrentUser[defaultCurrentUser.length - 1];
      localeDept = `${this.browserTreeKey}-${localeDept}`;
      const localeDeptDom = document.getElementById(localeDept);
      if (localeDeptDom) {
        const offsetTop = localeDeptDom.offsetTop;
        const scroller = jQuery(".scroller").has(`#${localeDept}`)[0];
        if (scroller) {
          scroller.scrollTop = offsetTop;
        }
      }
    }, 500);
  };
  expandChild = (expandKeysOrder, item, endHanlder) => {
    if (isEmpty(expandKeysOrder)) {
      if (typeof endHanlder == "function") {
        endHanlder();
      }
      return;
    }
    const itemKey = expandKeysOrder[0];
    if (!item) return;
    const cb = children => {
      let expandedKeys = this.state.expandedKeys;
      expandedKeys.push(itemKey);
      this.setState({ expandedKeys: uniq(expandedKeys) });
      this.expandChild(
        expandKeysOrder.slice(1),
        children.find(i => {
          i.treeKey = i.treeKey || `${itemKey}-${i.nodeid}`;
          return i.treeKey === expandKeysOrder[1];
        }),
        endHanlder
      );
    };
    if (item.isParent === "true" || item.isParent === true) {
      if (item.children.length == 0 && !item.isLoad) {
        this.fetchChildData(item).then(cb);
      } else {
        cb(item.children);
      }
    } else if (item.type == "com") {
      cb(item.children);
    }
  };
  fetchChildData = item => {
    const { dataUrl, keyword, params, asyncOtherParams = {} } = this.props;
    const browserType = this.props.type;
    const { isVirtual, type, id, treeKey } = item;
    let innerParams = { type: type, id: id, isVirtual: isVirtual };
    if (browserType == 4) innerParams.isLoadSubDepartment = 1;
    if (keyword) innerParams.keyword = keyword;
    let searchParams = { ...params, ...asyncOtherParams, ...innerParams };
    return new Promise(resolve => {
      WeaTools.callApi(dataUrl, "GET", searchParams)
        .then(datas => {
          item.isLoad = true;
          const treeData = [...this.state.treeData];
          this.getNewTreeData(
            treeData,
            treeKey,
            this.generateTreeNodes(datas, { props: item })
          );
          this.setState({ treeData });
          resolve(datas.datas);
        })
        .catch(e => this.props.onError && this.props.onError(e));
    });
  };
  onCheck(checkedKeys, e, inCheck = false) {
    const handleCheckedKeys = (cks, env) => {
      const { isMult, checkedCb, checkStrictly } = this.props;
      const checkedKey = env.node.props.treeKey;
      const checked = env.checked;
      if (isMult) {
        let selectNodes = [];
        let ids = [];
        // cks = cks.filter(
        //   k => checkStrictly || k.indexOf(checkedKey + "-") == -1
        // ); // 过滤子节点
        cks.forEach(i => {
          if (!this.isCheckedDisable(this.treeDataList[i])) {
            selectNodes.push(this.treeDataList[i]);
            ids.push(this.treeDataList[i].id);
          }
        });
        checkedCb && checkedCb(ids, selectNodes);
        // if (!this.state.checkStrictly && e.checked && !inCheck) {
        //   this.checkChild(
        //     [this.treeDataList[e.node.props.eventKey]],
        //     1,
        //     0,
        //     true,
        //     e.node.props.eventKey
        //   );
        // }
      }
    };
    if (!inCheck) {
      this.setState({ checkedKeys }, () => handleCheckedKeys(checkedKeys, e));
    } else {
      handleCheckedKeys(checkedKeys, e);
      // const { isMult } = this.props;
      // if (isMult) {
      //   let selectNodes = [];
      //   let ids = [];
      //   checkedKeys.forEach(i => {
      //     if (!this.isCheckedDisable(this.treeDataList[i])) {
      //       selectNodes.push(this.treeDataList[i]);
      //       ids.push(this.treeDataList[i].id);
      //     }
      //   });
      //   this.props.checkedCb && this.props.checkedCb(ids, selectNodes);
      //   // if (!this.state.checkStrictly && e.checked && !inCheck) {
      //   //   this.checkChild(
      //   //     [this.treeDataList[e.node.props.eventKey]],
      //   //     1,
      //   //     0,
      //   //     true,
      //   //     e.node.props.eventKey
      //   //   );
      //   // }
      // }
    }
  }
  onCheckedKeysChange(checkedKeys) {
    const { isMult, onCheckedKeysChange } = this.props;
    if (isMult) {
      let selectNodes = [];
      let ids = [];
      checkedKeys.forEach(i => {
        if (!this.isCheckedDisable(this.treeDataList[i])) {
          selectNodes.push(this.treeDataList[i]);
          ids.push(this.treeDataList[i].id);
        }
      });
      onCheckedKeysChange && onCheckedKeysChange(ids, selectNodes);
    }
  }
  // onHrmCheck(treeIds, treeNodes) {
  //   const { checkGroup = true } = this.props;
  //   let selectNodes = [];
  //   // 获取到所有不是人员节点
  //   const groupDatas = treeNodes.filter(item => {
  //     return item.nodeid.indexOf("resource") === -1;
  //   });
  //   // 获取到所有人员节点
  //   let resourceDatas = treeNodes.filter(item => {
  //     return item.nodeid.indexOf("resource") != -1;
  //   });
  //   // 可以选择部门，分部
  //   if (checkGroup) {
  //     groupDatas.forEach(group => {
  //       selectNodes.push(group);
  //       if (group.users && group.users.length) {
  //         resourceDatas = resourceDatas.filter(
  //           r => !group.users.find(u => u.nodeid == r.nodeid)
  //         );
  //       }
  //     });
  //   }
  //   selectNodes = [...selectNodes, ...resourceDatas];
  //   this.props.checkedCb &&
  //     this.props.checkedCb(selectNodes.map(d => d.nodeid), selectNodes);
  // }
  onHrmCheck(keys, info) {
    const { isSingle, checkGroup = true, checkStrictly } = this.props;
    const selectNodes = [];
    let targetKeys = cloneDeep(keys);
    targetKeys = targetKeys.filter(
      key =>
        this.treeDataList[key].canClick !== "false" &&
        this.treeDataList[key].type !== "com"
    );
    // 获取到所有不是人员节点的key
    const groupKeys = targetKeys.filter(item => {
      return item.indexOf("resource") === -1;
    });
    // 获取到所有人员节点的key
    const resourceKeys = targetKeys.filter(item => {
      return item.indexOf("resource") > -1;
    });
    if (checkGroup) {
      // 可以选择部门，分部
      targetKeys.forEach(i => {
        let targetNode = this.treeDataList[i];
        if (
          checkStrictly ||
          !groupKeys.some(key => targetNode.treeKey.indexOf(key + "-") > -1)
        ) {
          selectNodes.push(targetNode);
        }
      });
    } else {
      // 只能选择人
      resourceKeys.forEach(i => {
        selectNodes.push(this.treeDataList[i]);
      });
    }
    this.props.checkedCb && this.props.checkedCb(targetKeys, selectNodes);
  }
  onZTreeCheck(treeIds, treeNodes) {
    this.props.checkedCb && this.props.checkedCb(treeIds, treeNodes);
  }
  resetCheck() {
    this.setState({
      checkedKeys: []
    });
  }
  resetSelect() {
    this.setState({
      selectedKeys: []
    });
  }
  onSelect(keys, e) {
    const { isMult, isHrmTree, onSelect } = this.props;
    if (isHrmTree) {
      const nodes = e.selectedNodes;
      const eventKey = e.node.props.eventKey;
      this.setHrmDatas(nodes, eventKey);
    } else {
      if (typeof onSelect === "function") {
        onSelect(e);
      }
      if (!isMult) {
        this.setTheDatas(keys, e.selectedNodes);
      }
    }
  }
  onHrmSelect(selectedKeys, nodes) {
    if (nodes && nodes[0] && nodes[0].type === "resource") {
      this.onRadioCheck(nodes);
    }
  }
  onDoubleClick(key) {
    if (this.isCheckedDisable(this.treeDataList[key])) return;
    this.props.onDoubleClick &&
      this.props.onDoubleClick([this.treeDataList[key]]);
  }
  setHrmDatas(nodes, key) {
    let idArr = [];
    let dataArr = [];
    for (let i = 0; i < nodes.length; i++) {
      const node = nodes[i].props;
      if (node.type == "resource") {
        idArr.push(node.id);
        dataArr.push(node);
      }
    }
    let newIdArr = [];
    jQuery.each(idArr, function(i, el) {
      if (jQuery.inArray(el, newIdArr) === -1) newIdArr.push(el);
    });

    if (idArr.length > 0 && this.props.setData)
      this.props.setData(idArr, dataArr);
  }
  setTheDatas(selectTreeKeys, nodes) {
    let idArr = [];
    let nameArr = [];
    let keys = [];
    nodes = nodes || [];
    for (let i = 0, length = nodes.length; i < length; i++) {
      const node = nodes[i].props;
      if (node.canClick) {
        idArr.push(node.id);
        nameArr.push(node.name);
        keys.push(selectTreeKeys[i]);
      }
    }
    this.setState({
      selectedKeys: keys
    });
    let ids = idArr.join(",");
    let names = nameArr.join(",");
    if (ids && typeof this.props.setRadioData === "function") {
      this.props.setRadioData(ids, names);
    }
  }
  onLoadData(treeNode) {
    let _this = this;
    const {
      dataUrl,
      keyword,
      params,
      asyncOtherParams = {},
      isAccount,
      showDls
    } = this.props;
    const browserType = this.props.type;
    const treeData = [...this.state.treeData];
    const {
      eventKey,
      treeKey,
      isVirtual,
      type,
      psubcompanyid,
      id,
      level
    } = treeNode.props;
    // let params = `&type=${type}&id=${id}&isVirtual=${isVirtual}`;//（当前节点是部门的需要传递psubcompanyid）
    // (this.props.type == 4) && (params += '&isLoadSubDepartment=1');//加载部门
    let innerParams =
      browserType == 4
        ? { isLoadSubDepartment: 1, type: type, id: id, isVirtual: isVirtual }
        : { type: type, id: id, isVirtual: isVirtual };
    if (keyword) innerParams.keyword = keyword;
    if (isAccount) innerParams.isAccount = 1;
    if (showDls) innerParams.showDls = 1;
    let searchParams = {
      ...params,
      ...asyncOtherParams,
      ...innerParams,
      level: level
    };
    return new Promise(resolve => {
      WeaTools.callApi(dataUrl, "GET", searchParams)
        .then(datas => {
          this.getNewTreeData(
            treeData,
            treeKey,
            this.generateTreeNodes(datas, treeNode.props.treeKey),
            2
          );
          _this.setState({ treeData });
          let checkedKeys = _this.formatCheckDatas(_this.state.checkedDatas);
          _this.setState({ checkedKeys });
          resolve();
        })
        .catch(e => this.props.onError && this.props.onError(e));
    });
  }
  checkChild(
    items,
    level,
    defaultExpandedLevel,
    needCheck = false,
    parentKey = ""
  ) {
    items = [...objToArray(items)];
    items.forEach(item => {
      if (!item.treeKey) {
        item.treeKey = parentKey + "-" + (item.nodeid || item.id);
        if (item.type === "1") {
          item.treeKey += "type1";
        }
      }
      item.children = item.subs || item.children || [];
      if (
        ((defaultExpandedLevel && level <= defaultExpandedLevel) ||
          !defaultExpandedLevel ||
          this.props.asynLoadAll) &&
        item.isParent
      ) {
        if (item.children.length == 0 && !item.isLoad) {
          this.fetchChildDataByLevel(
            item,
            level,
            defaultExpandedLevel,
            needCheck,
            item.treeKey
          ).then(() => {
            // this.generateData(item, level)
            let expandedKeys = this.state.expandedKeys;
            let checkedKeys = this.state.checkedKeys;
            if (level <= defaultExpandedLevel || defaultExpandedLevel === 0) {
              expandedKeys.push(item.treeKey);
              if (needCheck) {
                checkedKeys.push(item.treeKey);
                this.onCheck(uniq(checkedKeys), { checked: true }, true);
              }
            }
            // this.setState({treeData: objToArray(items), expandedKeys: expandedKeys, checkedKeys: checkedKeys})
            this.setState({
              expandedKeys: expandedKeys,
              checkedKeys: uniq(checkedKeys)
            });
          });
        }
        if (item.children.length > 0) {
          this.checkChild(
            item.children,
            level + 1,
            defaultExpandedLevel,
            needCheck
          );
        }
      } else {
        if (needCheck) {
          let checkedKeys = this.state.checkedKeys;
          checkedKeys.push(item.treeKey);
          this.onCheck(uniq(checkedKeys), { checked: true }, true);
          this.setState({ checkedKeys: uniq(checkedKeys) });
        }
      }
    });
  }
  fetchChildDataByLevel(
    item,
    level,
    defaultExpandedLevel,
    needCheck = false,
    parentKey
  ) {
    const { dataUrl, keyword, params, asyncOtherParams = {} } = this.props;
    const browserType = this.props.type;
    const { isVirtual, type, id } = item;
    let innerParams = { type: type, id: id, isVirtual: isVirtual };
    if (browserType == 4) innerParams.isLoadSubDepartment = 1;
    if (keyword) innerParams.keyword = keyword;
    let searchParams = { ...params, ...asyncOtherParams, ...innerParams };
    return new Promise(resolve => {
      WeaTools.callApi(dataUrl, "GET", searchParams)
        .then(datas => {
          item.children = datas.datas;
          item.isLoad = true;

          const treeData = [...this.state.treeData];
          this.getNewTreeData(
            treeData,
            parentKey,
            this.generateTreeNodes(datas, parentKey)
          );
          this.setState({ treeData });
          let checkedKeys = this.formatCheckDatas(this.state.checkedDatas);
          this.setState({ checkedKeys });

          this.checkChild(
            item.children,
            level + 1,
            defaultExpandedLevel,
            needCheck,
            parentKey
          );
          resolve();
        })
        .catch(e => this.props.onError && this.props.onError(e));
    });
  }
  fetchChildDatas() {
    const treeData = [...this.state.treeData];
    const defaultExpandedLevel = parseInt(this.props.defaultExpandedLevel) || 1;
    let currentLevel = 1;

    if (treeData) {
      this.checkChild(treeData, currentLevel, defaultExpandedLevel);
    } else {
      return false;
    }
  }
  isCheckedDisable(item) {
    const {
      filterData,
      inputId,
      inputName,
      checkStrictly,
      isHrmTree
    } = this.props;
    if (!item) return true;
    if (isHrmTree) {
      if (item.canClick == "false") {
        return true;
      }
      if (filterData && filterData.length) {
        return filterData.some(d => item.id === d.id && item.type === d.type);
      }
      return false;
    }
    if (
      !item.canClick &&
      !(
        !checkStrictly &&
        // item.treeKey &&
        // item.treeKey.indexOf("type1") !== -1 &&
        item.isParent
      )
    ) {
      return true;
    }
    if (!isEmpty(filterData)) {
      let id = inputId || "id";
      let name = inputName || "name";
      return filterData.some(
        d =>
          item[id] === d[id] &&
          (item[name] || item.name || item.orgWholePathspan) ===
            (d[name] || d.name || d.orgWholePathspan)
      );
    }
    return false;
  }
  isRadioDisable(item) {
    const { isHrmTree } = this.props;
    if (isHrmTree) {
      return true;
    } else {
      return !item.canClick || false;
    }
  }
  isRadioChecked(item) {
    let bool = false;
    const { radioCheckedData } = this.state;
    if (!isEmpty(radioCheckedData)) {
      if (isString(radioCheckedData)) {
        bool = item.treeKey == radioCheckedData;
      } else {
        bool = item.id == radioCheckedData.id;
      }
    }
    return bool;
  }
  onExpandChange(expandedKeys, nodeObj) {
    this.setState({
      expandedKeys: expandedKeys,
      ztreeExpandedKeys: expandedKeys
    });
  }
  onRadioCheck(key) {
    const { ztreeMode, setRadioData } = this.props;
    let data = null;
    if (ztreeMode && key && key.length > 0) {
      data = key[0];
    } else if (key) {
      data = this.treeDataList[key];
    }
    if (data) {
      this.setState({ radioCheckedData: data });
      setRadioData &&
        setRadioData(
          data.id,
          data.orgWholePathspan || data.name || data.lastname,
          data
        );
    } else {
      this.setState({ radioCheckedData: null });
      setRadioData && setRadioData("", "", null);
    }
  }
  getDisplayName = item => {
    let showName;
    let displayKeys = [];
    if (item && item.displayKeys) {
      if (typeof item.displayKeys === "string") {
        displayKeys = item.displayKeys.split(",");
      } else if (Array.isArray(item.displayKeys)) {
        displayKeys = item.displayKeys;
      }
    }
    if (!isEmpty(displayKeys)) {
      showName = displayKeys.map(field => text(item, field)).join(" ");
    }
    return showName ? (
      <span
        style={{ paddingLeft: 10 }}
        title={showName}
        dangerouslySetInnerHTML={{ __html: showName }}
      />
    ) : (
      showName
    );
  };
  getHrmTitle = item => {
    const { icon, hasRight } = this.props;
    let title;
    const displayName = this.getDisplayName(item);
    let showName = displayName || item.lastname;
    if (item.type == "com") {
      title = (
        <div>
          {typeof icon === "string" ? <span className={icon} /> : icon}
          {showName}
          <span className="wea-f12" style={{ color: "#979797" }}>
            {/*人数占位*/}
          </span>
        </div>
      );
    } else if (item.type == "subcom") {
      title = (
        <div>
          <i className="icon-process-scene" />
          {showName}
        </div>
      );
    } else if (item.type == "dept") {
      title = (
        <div id={`${this.browserTreeKey}-${item.treeKey}`}>
          <i className="icon-mail-folder" /> {showName}
        </div>
      );
    } else if (item.type == "resource") {
      if (!displayName) {
        showName = [
          <span style={{ paddingLeft: 10, color: "#333" }}>
            {item.lastname}
          </span>,
          <span style={{ color: "#929390", paddingLeft: 10 }}>
            {item.jobtitlename}
          </span>
        ];
      }
      title = (
        <div className="wea-f12">
          {/* <img className="wea-tree-hr-portrait" src={item.icon} alt="img" /> */}
          <WeaAvatar className="wea-tree-hr-portrait" userId={item.id} />
          {showName}
        </div>
      );
    } else {
      // add: !item.pid存在 父节点 && (私人组 || 有权限的公共组  (isPrivate并不是都有这个参数))
      // edit: item.pid 子节点 && (私人组 || 有权限的公共组)
      // advice: item.pid 子节点 && 没有权限的公共组（可以提交调整公共组建议）
      const canAdd =
        !item.pid &&
        (item.isPrivate === "true" ||
          (item.isPrivate === "false" && hasRight === 1));
      let canEdit = false;
      if (item.canEdit) {
        canEdit =
          item.pid &&
          (item.isPrivate === "true" ||
            (item.isPrivate === "false" && item.canEdit === "true"));
      } else {
        canEdit =
          item.pid &&
          (item.isPrivate === "true" ||
            (item.isPrivate === "false" && hasRight === 1));
      }
      const canAdvice =
        item.pid && item.isPrivate === "false" && hasRight !== 1;
      title = (
        <div>
          <i className={item.cusIcon || "icon-process-scene"} />
          {item.cusIcon ? (
            <span style={{ paddingLeft: 10 }}>{showName}</span>
          ) : (
            showName
          )}
          <span className="wea-tree-hr-node">
            {canAdd && (
              <span
                className="wea-tree-hr-node-icon"
                title={getLabel("611", "添加")}
                onClick={e =>
                  this.groupDialog &&
                  this.groupDialog.opsHandler("add", e, item)
                }
              >
                <i className="icon-coms-Add-to" />
              </span>
            )}
            {canEdit && [
              <span
                className="wea-tree-hr-node-icon"
                title={getLabel("26473", "编辑")}
                onClick={e =>
                  this.groupDialog &&
                  this.groupDialog.opsHandler("edit", e, item)
                }
              >
                <i className="icon-coms-edit" />
              </span>,
              <span
                className="wea-tree-hr-node-icon"
                title={getLabel(91, "删除")}
                onClick={e =>
                  this.groupDialog &&
                  this.groupDialog.opsHandler("delete", e, item)
                }
              >
                <i className="icon-coms-delete" />
              </span>
            ]}
            {canAdvice && (
              <span
                className="wea-tree-hr-node-icon"
                title={getLabel(16159, "建议")}
                onClick={e =>
                  this.groupDialog &&
                  this.groupDialog.opsHandler("advice", e, item)
                }
              >
                <i className="icon-coms-Advice" />
              </span>
            )}
          </span>
        </div>
      );
    }
    return title;
  };
  getTitle = item => {
    const { isLoadUser, renderItem } = this.props;
    const showName =
      this.getDisplayName(item) ||
      item.displayName ||
      item.name ||
      item.lastname;
    let title = (
      <div title={item.title || item.name || item.lastname}>
        {item.icon && (
          <i className={item.icon} style={{ marginRight: "5px" }} />
        )}
        {showName}
      </div>
    );
    if (isLoadUser && item.type == "3") {
      title = (
        <div style={{ position: "relative", paddingLeft: 30 }}>
          {/* <img
            className="wea-tree-hr-portrait"
            style={{
              width: 30,
              height: 30,
              padding: 1,
              position: "absolute",
              top: 1,
              left: 1
            }}
            src={item.icon}
            alt="portrait"
          /> */}
          <WeaAvatar className="wea-tree-hr-portrait" userId={item.id} />
          <span style={{ paddingLeft: 10 }}>{showName}</span>
        </div>
      );
    }
    if (item.isImgIcon) {
      title = (
        <div className="wea-f12">
          <img
            className="wea-tree-hr-portrait"
            src={item.icon}
            onError={() =>
              (item.icon =
                "/cloudstore/resource/pc/com/images/portrait_default.jpg")
            }
            alt="img"
          />
          <span style={{ paddingLeft: 10 }}>{showName}</span>
        </div>
      );
    }
    if (renderItem) {
      title = renderItem(item);
    }
    return title;
  };
  render() {
    const {
      treeData,
      expandedKeys,
      defaultExpandedKeys,
      selectedKeys,
      checkStrictly,
      radioCheckedData,
      checkedDatas,
      checkedKeys,
      ztreeExpandedKeys
    } = this.state;
    const {
      browserTree,
      isMult,
      hasRadio,
      isLoadAll = false,
      ztreeMode,
      isHrmTree
    } = this.props;
    const loop = (data, level) =>
      data.map(item => {
        if (item.children) {
          for (let i = 0; i < item.children.length; i++) {
            item.children[i].treeKey = `${item.treeKey}-${item.children[i]
              .nodeid || item.children[i].id}`;
            if (item.children[i].type === "1") {
              item.children[i].treeKey += "type1";
            }
            // item.children[i].isParent ? (item.children[i].isLeaf = false) : (item.children[i].isLeaf = true);
          }
        }
        this.treeDataList[item.treeKey] = item;
        const title = isHrmTree ? this.getHrmTitle(item) : this.getTitle(item);
        return (
          <TreeNode
            browserTree={browserTree}
            level={level}
            isVirtual={item.isVirtual}
            type={item.type}
            title={title}
            name={item.name}
            lastname={item.lastname}
            jobtitlename={item.jobtitlename}
            key={item.treeKey}
            id={item.id}
            treeKey={item.treeKey}
            isLeaf={item.isLeaf}
            disableCheckbox={this.isCheckedDisable(item)}
            disableRadio={this.isRadioDisable(item)}
            radioChecked={this.isRadioChecked(item)}
            expanded={true}
            canClick={item.canClick}
          >
            {item.children && loop(item.children, level + 1)}
          </TreeNode>
        );
      });
    this.treeDataList = {};
    const treeNodes = treeData.length > 0 ? loop(treeData, 0) : null;
    let ztreeProps = {};
    if (ztreeMode) {
      ztreeProps = {
        checkable: true,
        ztreeMode,
        browserTree: false,
        onCheck: (isMult
          ? this.onZTreeCheck
          : (treeId, treeNode) => this.onRadioCheck(treeNode)
        ).bind(this),
        onSelect: (isHrmTree ? this.onHrmSelect : this.onSelect).bind(this),
        getTitle: isHrmTree ? this.getHrmTitle : this.getTitle,
        checkedKeys: isMult
          ? (checkedDatas || []).map(d => d.id)
          : radioCheckedData && radioCheckedData.id
          ? [radioCheckedData.id]
          : [],
        expandedKeys: ztreeExpandedKeys,
        checkStrictly: isMult ? checkStrictly : false
      };
    }
    // let checkedKeys = this.state.checkedKeys;
    // if (isEmpty(checkedKeys) && !isEmpty(checkedDatas)) {
    //   checkedKeys = this.formatCheckDatas(checkedDatas);
    //   if (!isEmpty(checkedKeys)) {
    //     this.updateExpandedKeys(checkedKeys, this.props.defaultExpandedKeys);
    //     this.setState({ checkedKeys });
    //   }
    // }
    return [
      <Tree
        {...this.props}
        className={`${this.props.className || ""} my-tree`}
        defaultExpandedKeys={defaultExpandedKeys}
        expandedKeys={expandedKeys}
        onExpand={this.onExpandChange.bind(this)}
        onSelect={this.onSelect.bind(this)}
        onCheck={(isHrmTree ? this.onHrmCheck : this.onCheck).bind(this)}
        loadData={isLoadAll ? null : this.onLoadData.bind(this)}
        checkable={isMult}
        checkedKeys={this.props.checkedKeys || checkedKeys}
        checkStrictly={checkStrictly}
        onRadioCheck={this.onRadioCheck.bind(this)}
        hasRadio={hasRadio}
        multiple={isMult}
        selectedKeys={selectedKeys}
        needExpandChildren
        clickNameExpandNode
        clickNodeExpandChildren={!hasRadio && !isMult}
        onDoubleClick={this.onDoubleClick.bind(this)}
        // autoExpandParent={false}
        {...ztreeProps}
      >
        {!ztreeMode && treeNodes}
      </Tree>,
      isHrmTree && (
        <GroupDialog {...this.props} ref={ref => (this.groupDialog = ref)} />
      )
    ];
  }
}

function generateData(data, level = 1, defaultExpandedKeys = []) {
  if (!isEmpty(data)) {
    const { topPrefix, defaultExpandedLevel } = this.props;
    if (!isArray(data)) {
      data.isLeaf = data.isParent === false || data.isParent === "false";
      // data.isLeaf = !data.isParent;
      if (level == 1) data.treeKey = `${topPrefix}0-${data.nodeid || data.id}`;
      data.children = data.subs || data.children;
      if (defaultExpandedLevel > 0 && defaultExpandedLevel >= level) {
        defaultExpandedKeys.push(data.treeKey || data.id);
      }
      if (data.children && data.children.length > 0)
        this.generateData(data.children, level + 1, defaultExpandedKeys);
    } else {
      data.forEach(item => {
        item.isLeaf = item.isParent === false || item.isParent === "false";
        // item.isLeaf = !item.isParent;
        if (level == 1)
          item.treeKey = `${topPrefix}0-${item.nodeid || item.id}`;
        item.children = item.subs || item.children;
        if (defaultExpandedLevel > 0 && defaultExpandedLevel >= level) {
          defaultExpandedKeys.push(item.treeKey || item.id);
        }
        if (item.children && item.children.length > 0)
          this.generateData(item.children, level + 1, defaultExpandedKeys);
      });
    }
  }
}

function generateTreeNodes(data, treeKey) {
  let datas = data;
  if (!data.length) {
    datas = new Array(datas);
  }
  let arr = new Array();
  const { topPrefix } = this.props;
  if (!treeKey) {
    for (let i = 0; i < datas.length; i++) {
      const data = datas[i];
      data.treeKey = `${topPrefix}0-${data.nodeid || data.id}`;
      data.isLeaf = data.isParent === false || data.isParent === "false";
      // data.isLeaf = !data.isParent;
      data.children = data.subs || data.children;
      arr.push(data);
    }
  } else {
    const loop = datas => {
      for (let i = 0; i < datas.length; i++) {
        const data = datas[i];
        data.treeKey = `${treeKey}-${data.nodeid || data.id}`;
        if (data.type === "1") {
          data.treeKey += "type1";
        }
        // data.isLeaf = !data.isParent;
        data.isLeaf = data.isParent === false || data.isParent === "false";
        arr.push(data);
      }
    };
    loop(datas[0].datas);
  }
  return arr;
}

function getNewTreeData(treeData, curKey, child, level) {
  const loop = data => {
    data.forEach(item => {
      if ((curKey + "-").indexOf(item.treeKey + "-") === 0) {
        if (!isEmpty(item.children)) {
          loop(item.children);
        } else {
          item.children = child;
        }
      }
    });
  };
  loop(treeData);
}
export default Main;



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/components/WeaBrowserTree.js